(function($, App, Utils){
  'use strict';

  var logger = new Logger('Responsive');

  Utils.add('Responsive', {

    Events: {
      Ready: "resolution:ready",
      ResolutionEnter: "resolution:enter",
      ResolutionExit: "resolution:exit",
      ResolutionChanged: "resolution:changed"
    },

    _sm: 640,

    _md: 1024,

    _lg: 1200,

    isXS: function () {
      return Utils.Responsive.currentResolution.enter < Utils.Responsive._sm
    },

    isSM: function () {
      return Utils.Responsive.currentResolution.enter >= Utils.Responsive._sm && Utils.Responsive.currentResolution.exit < Utils.Responsive._md
    },

    isMD: function () {
      return Utils.Responsive.currentResolution.enter >= Utils.Responsive._md && Utils.Responsive.currentResolution.exit < Utils.Responsive._lg
    },

    isLG: function() {
      return Utils.Responsive.currentResolution.enter >= Utils.Responsive._lg
    },

    resObj: {},

    currentResolution: {},
    previousResolution: null,

    resHandler:  function (number) {

      Utils.Responsive.resObj = jRespond(Utils.Responsive.resConf);

      $.each(Utils.Responsive.resConf, function(index, item){

        Utils.Responsive.resObj.addFunc({
          breakpoint: item.label,
          enter: function() {
            logger.debug("Enter res", item);
            Utils.Responsive.currentResolution = item;
            $(Utils.Responsive).trigger(Utils.Responsive.Events.ResolutionEnter, [item]);

            // 'enter' will be fired after 'exit': we can fire our custom event
            $(Utils.Responsive).trigger(Utils.Responsive.Events.ResolutionChanged, [Utils.Responsive.previousResolution, Utils.Responsive.currentResolution]);

          },
          exit: function() {
            logger.debug("Exit res", item);
            Utils.Responsive.previousResolution = item;
            $(Utils.Responsive).trigger(Utils.Responsive.Events.ResolutionExit, [item]);
          }
        });

      });


      Utils.Responsive.currentResolution = this.getCurrentResolution();

      $(App).on(App.Events.Ready, function(e) {
        $(Utils.Responsive).trigger(Utils.Responsive.Events.Ready, Utils.Responsive.currentResolution);
        $(Utils.Responsive).trigger(Utils.Responsive.Events.ResolutionEnter, [Utils.Responsive.currentResolution]);
      });

    },

    getCurrentResolution: function() {
      var lbl = Utils.Responsive.resObj.getBreakpoint();
      for( var i = 0, l = Utils.Responsive.resConf.length; i < l; i++ ) {
        if ( Utils.Responsive.resConf[i].label === lbl ) {
          return Utils.Responsive.resConf[i];
        }
      }
    },

    init: function() {

      Utils.Responsive.resConf = [{
        label: 'xs',
        enter: 0,
        exit: (Utils.Responsive._sm - 1)
      },
      {
        label: 'sm',
        enter: Utils.Responsive._sm,
        exit: (Utils.Responsive._md - 1)
      },
      {
        label: 'md',
        enter: Utils.Responsive._md,
        exit: (Utils.Responsive._lg - 1)
      },
      {
        label: 'lg',
        enter: Utils.Responsive._lg,
        exit: 100000
      }];

      Utils.Responsive.resHandler();
    }
  });

})(jQuery, window.App, window.App.Utils);
